var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("权限不足，请联系管理员！")]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.tip))]),_vm._v(" "),_c('router-link',{staticStyle:{"float":"left","font-size":"18px"},attrs:{"to":_vm.sysPath}},[_vm._v(_vm._s(_vm.sysName))]),_vm._v(" "),_c('router-link',{staticStyle:{"float":"right","font-size":"18px"},attrs:{"to":"/login"}},[_vm._v("回到登陆")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06125975","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/noRight.vue
// module id = null
// module chunks = 